// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"e4748184","362":"e269b829","377":"3cf489d7"}[chunkId] + ".chunk.js";
};